export default "__VITE_ASSET__DDWFxNLB__"